module.exports = __webpack_public_path__ + "static/img/00.56fe1fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commodity/02/00.jpg
// module id = gRgy
// module chunks = 0